/*
 * @Author: your name
 * @Date: 2020-06-03 15:21:11
 * @LastEditTime: 2020-06-03 17:17:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\common\components\form-staff-selector\staff-selector-mappings.ts
 */
import * as tslib_1 from "tslib";
import { userApi } from "./../../../../../api";
import { renderer } from './../../../../../form';
const MAPPING_FIELD_OPERATE = "MAPPING_FIELD_OPERATE";
export class StaffSelectorMapping {
    static mappingOperate(val, mappings, vm) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _tempMappingItem = ["departments", "partTimerDepartment", "manager"];
            let self = StaffSelectorMapping;
            let dirty = false; // val 是否被修改标记
            let mappingList = mappings
                .slice(0, -1)
                .split(";")
                .map((val) => val.split(":"));
            for (let _mapping of mappingList) {
                let [mappingItem, mappingKey] = _mapping;
                if (self[MAPPING_FIELD_OPERATE + mappingItem]) {
                    if (mappingItem === "departments" &&
                        (!val[0]["departments"] || val[0]["departments"].length > 1)) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}${mappingItem}`](val[0], vm);
                    }
                    else if (mappingItem === "partTimerDepartment" && !val[0]["partTimerDepartment"]) {
                        dirty = true;
                        //外链不能访问此组织接口，不支持
                        if (!vm.isExternal) {
                            yield self[`${MAPPING_FIELD_OPERATE}${mappingItem}`](val[0], vm);
                        }
                    }
                    else if (!val[0][mappingItem]) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}${mappingItem}`](val[0]);
                    }
                }
                else if (~mappingItem.indexOf("LEVEL")) {
                    if (!val[0][mappingItem]) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}OrganizationLevel`](val[0], mappingItem, vm);
                    }
                }
                else if (!_tempMappingItem.includes(mappingItem) && vm.val) {
                    if (typeof vm.val !== typeof val || vm.val.length !== val.length) {
                        dirty = true;
                    }
                    else {
                        if (vm.val[0][mappingItem] !== val[0][mappingItem]) {
                            dirty = true;
                        }
                    }
                }
                else if (mappingItem.indexOf('entryDate') > -1) {
                    if (val[0][mappingItem] && typeof val[0][mappingItem] === 'string') {
                        val[0][mappingItem] = val[0][mappingItem].replace(/-/g, '/');
                        val[0][mappingItem] = new Date(val[0][mappingItem]);
                        dirty = true;
                    }
                }
                else {
                    // ID1012396 支持用户拓展信息映射
                    if (!val[0].hasOwnProperty(mappingItem)) {
                        dirty = true;
                        yield self[`${MAPPING_FIELD_OPERATE}extAttr`](val[0], mappingItem, vm);
                    }
                }
            }
            if (dirty) {
                let newVal = JSON.parse(JSON.stringify(val));
                vm.setValue(newVal);
                vm.val && (vm.val = val);
            }
            else {
                vm.val && (vm.val = val);
            }
        });
    }
    static [MAPPING_FIELD_OPERATE + 'extAttr'](item, key, vm) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (Array.isArray(item.userExtAttrModels) && item.userExtAttrModels.length > 0) {
                    let extItem = item.userExtAttrModels.find((item) => item.code === key);
                    if (extItem) {
                        item[key] = extItem.mapVal;
                    }
                    resolve(item);
                }
            }));
        });
    }
    // 用户 主部门和兼职部门信息. 两种情况,1. 部门信息都在一个 departments里面,需要区分. 2. 部门信息没有需要额外请求接口
    static [MAPPING_FIELD_OPERATE + "departments"](item, vm) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (item.departments && item.departments.length > 1) {
                    let _department = [];
                    let _partTimerDepartments = [];
                    for (let dp of item.departments) {
                        if (dp.id !== item.departmentId) {
                            _partTimerDepartments.push(dp);
                        }
                        else {
                            _department.push(dp);
                        }
                    }
                    item["partTimerDepartment"] = _partTimerDepartments;
                    item["departments"] = _department;
                    resolve(item);
                }
                else if (!item.departments) {
                    let { errcode, data, errmsg } = yield userApi.getUserInfo(item.id);
                    if (errcode === 0) {
                        if (data) {
                            let { mainDepartmentName, departmentNames } = data;
                            item["departments"] = mainDepartmentName
                                ? [mainDepartmentName]
                                : [];
                            item["partTimerDepartment"] =
                                departmentNames && departmentNames.length ? departmentNames : [];
                        }
                    }
                    else {
                        vm.$message.error(errmsg);
                    }
                    resolve(item);
                }
            }));
        });
    }
    static [MAPPING_FIELD_OPERATE + "partTimerDepartment"](item, vm) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                let { errcode, data, errmsg } = yield userApi.getUserInfo(item.id);
                if (errcode === 0) {
                    if (data) {
                        let { mainDepartmentName, departmentNames } = data;
                        item["departments"] = mainDepartmentName
                            ? [mainDepartmentName]
                            : [];
                        item["partTimerDepartment"] =
                            departmentNames && departmentNames.length ? departmentNames : [];
                    }
                }
                else {
                    vm.$message.error(errmsg);
                }
                resolve(item);
            }));
        });
    }
    // 映射字段-manager-主管信息 获取
    static [MAPPING_FIELD_OPERATE + "manager"](item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                renderer.StaffSelectorControl.service.getDeptLeader(item.id).then((data) => {
                    if (Array.isArray(data)) {
                        if (data.length) {
                            item["manager"] = data;
                        }
                        else {
                            item["manager"] = [];
                        }
                    }
                    else {
                        item["manager"] = [];
                    }
                    resolve(item);
                });
            });
        });
    }
    // 映射字段-xxx-LEVEL,x -部门信息 获取
    static [MAPPING_FIELD_OPERATE + "OrganizationLevel"](item, levelString, vm) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                renderer.StaffSelectorControl.service.getOrganizationLevel(item.id).then(data => {
                    if (vm.controlOpts) {
                        if (data) {
                            if (data.length > 0) {
                                let level = levelString.split(",")[1];
                                //判断当前返回的组织层级是否与映射的组织层级对应
                                if (level < data.length) {
                                    item[levelString] = [];
                                    item[levelString].push(data[level]);
                                }
                                else {
                                    item[levelString] = [];
                                    item[levelString].push(data[data.length - 1]);
                                }
                            }
                            else {
                                item[levelString] = [];
                            }
                        }
                        else {
                            item[levelString] = [];
                        }
                    }
                    resolve(true);
                });
            });
        });
    }
}
